import { useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../lib/api';

export interface SetupStep {
  id: string;
  label: string;
  description: string;
  href: string;
  complete: boolean;
}

export interface SetupProgress {
  steps: SetupStep[];
  completedCount: number;
  totalCount: number;
  allComplete: boolean;
  percentComplete: number;
  /** Server-side wizard state (source of truth for the first-run redirect) */
  onboarding?: {
    completed_at: string | null;
    skipped_at: string | null;
  };
}

export function useSetupProgress() {
  return useQuery<SetupProgress>({
    queryKey: ['setup-progress'],
    queryFn: async () => {
      const { data } = await api.get('/api/setup-progress');
      return data;
    },
    // Refresh every 30s so steps auto-check as users complete them
    refetchInterval: 30_000,
    staleTime: 15_000,
  });
}

/** Call this to immediately re-check progress after the user completes an action */
export function useRefreshSetupProgress() {
  const queryClient = useQueryClient();
  return () => queryClient.invalidateQueries({ queryKey: ['setup-progress'] });
}
